import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
function FormError({ className, children }) {
    return (_jsx("div", { className: clsx('mt-2 text-sm text-red-600 dark:text-red-500', className), children: children }));
}
export default FormError;
//# sourceMappingURL=index.js.map